export enum E_MIDDLEWARE_STEPS {
  CHANGE = 'middleware-steps:change',
  RESULT = 'middleware-steps:result',
}